import { BWMModel } from '../models/bwm-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { ZoneLayerBase } from './zone-layer-base';

export class BWMLayer extends ZoneLayerBase {
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await BWMModel!.getBWMZones();
        return zones || [];
    }
    
    zoneId: string = "BWMLayer";
}
